import playbooks from 'modules/playbooks/reducer'
import playbookEpic from 'modules/playbooks/epic'

export const rootReducer = [
  {
    key: 'playbooks',
    reducer: playbooks,
  }
]


export const rootEpic = [
  playbookEpic,
]
